import phoneValidate from 'helpers/validates/phone'

import validations from 'constants/validations'

const { STRING_SCHEMA_TYPE } = validations

const phone = {
  name: 'phone',
  schemaType: STRING_SCHEMA_TYPE,
  method({ required = false, message = 'Número de telefone inválido' } = {}) {
    const schema = required ? this.required() : this

    return schema.test('is-valid-phone', message, (value) =>
      phoneValidate.schema({ value, required }),
    )
  },
}

export default phone
